import { useEffect, useState } from "react";
import {
  useMypageAlarmInfo,
  useUpdateMypageAlarmInfo,
} from "~/services/customer/myPage";

interface PushInfoType {
  alarmEmailYn: string | null;
  alarmMarketingYn: string | null;
  alarmNoticeYn: string | null;
  alarmSmsYn: string | null;
}

const initialPushInfo: PushInfoType = {
  alarmEmailYn: null,
  alarmMarketingYn: null,
  alarmNoticeYn: null,
  alarmSmsYn: null,
};

const useMyPagePush = () => {
  const { data: mypageAlarmInfo } = useMypageAlarmInfo();
  const [pushInfo, setPushInfo] = useState<PushInfoType>(initialPushInfo);
  const updateAlarmInfo = useUpdateMypageAlarmInfo();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (mypageAlarmInfo) {
      setPushInfo(mypageAlarmInfo);
    }
  }, [mypageAlarmInfo]);

  // 대상 회원은 서버가 액세스 토큰에서 판별한다(AuthenticationUtil.getCurrentUserSeq).
  // 따라서 요청 바디에 userSeq 를 실어 보내지 않는다.
  const handlePushInfo = async (
    key: keyof PushInfoType,
    value: string | null
  ) => {
    const prevPushInfo = pushInfo;
    const newPushInfo = { ...pushInfo, [key]: value };

    setPushInfo(newPushInfo);
    setErrorMessage(null);

    try {
      await updateAlarmInfo.mutateAsync({
        alarmEmailYn: newPushInfo.alarmEmailYn || "N",
        alarmMarketingYn: newPushInfo.alarmMarketingYn || "N",
        alarmNoticeYn: newPushInfo.alarmNoticeYn || "N",
        alarmSmsYn: newPushInfo.alarmSmsYn || "N",
      });
    } catch (error) {
      console.error("알림 설정 업데이트 실패:", error);
      // 실패 시 이전 상태로 복구하고 사용자에게 알린다.
      setPushInfo(prevPushInfo);
      setErrorMessage("알림 설정을 저장하지 못했습니다. 잠시 후 다시 시도해주세요.");
    }
  };

  return {
    pushInfo,
    handlePushInfo,
    isUpdating: updateAlarmInfo.isPending,
    errorMessage,
    clearErrorMessage: () => setErrorMessage(null),
  };
};

export default useMyPagePush;
